
(function () {
  const DPI = 300;
  const HOLE = 0.313;

  function piecesFor(size, pack) {
    const label = size === 12 ? 4 : 3.5;

    const circle = (key, title, inch) => ({
      key, title, inch, circle: true
    });

    const square = (key, title, inch) => ({
      key, title, inch, circle: false
    });

    if (size === 10) {
      return [circle('CNC-Artwork', 'CNC engraving', 3.5)];
    }

    const out = [];

    if (pack !== 'jacket') {
      out.push(
        circle('Label-A', 'Label A', label),
        circle('Label-B', 'Label B', label)
      );
    }

    if (pack !== 'labels') {
      out.push(
        square('Jacket-Front', 'Jacket front', size),
        square('Jacket-Back', 'Jacket back', size)
      );
    }

    return out;
  }

  function imageScale(p) {
    const n = Math.round(p.inch * DPI);
    const w = p.image.naturalWidth;
    const h = p.image.naturalHeight;
    const a = p.angle * Math.PI / 180;
    const c = Math.abs(Math.cos(a));
    const s = Math.abs(Math.sin(a));

    const base = p.mode === 'fit'
      ? Math.min(n / (w * c + h * s), n / (w * s + h * c))
      : Math.max(n * (c + s) / w, n * (c + s) / h);

    return base * p.zoom;
  }

  function movingItem(p){if(p.artMode==='design'&&p.selectedShape>=0&&p.shapes?.[p.selectedShape])return p.shapes[p.selectedShape];if(p.artMode==='design'&&p.selectedText){p.textPositions??={};return p.textPositions[p.selectedText]??={x:0,y:0};}return activeImage(p);}
  function activeImage(p){return p.artMode==='design'&&p.selectedLayer>=0&&p.layers?.[p.selectedLayer]?p.layers[p.selectedLayer]:p;}
  function hasDesign(p){if((p.artMode||'upload')==='upload')return !!p.image;return !!(p.image||p.layers?.length||p.shapes?.length||p.labelTitle?.trim()||p.labelArtist?.trim()||p.songTitles?.trim()||p.sideText?.trim()||p.catalogText?.trim()||p.creditsText?.trim()||p.backgroundEnabled||p.ring&&p.ring!=='none');}
  function curvedText(ctx,text,size,radius,bottom,fontSize,font='Arial'){
    const chars=Array.from(text);ctx.font='700 '+fontSize+'px '+font;
    const widths=chars.map(c=>ctx.measureText(c).width+fontSize*.06);const total=widths.reduce((a,b)=>a+b,0);
    const fit=Math.min(1,(Math.PI*.82*radius)/Math.max(total,1));fontSize*=fit;ctx.font='700 '+fontSize+'px '+font;
    const arc=total*fit/radius;let used=0;ctx.textAlign='center';ctx.textBaseline='middle';
    for(let i=0;i<chars.length;i++){const w=widths[i]*fit;const a=bottom?Math.PI/2+arc/2-(used+w/2)/radius:-Math.PI/2-arc/2+(used+w/2)/radius;ctx.save();ctx.translate(size/2+radius*Math.cos(a),size/2+radius*Math.sin(a));ctx.rotate(bottom?a-Math.PI/2:a+Math.PI/2);ctx.fillText(chars[i],0,0);ctx.restore();used+=w;}
  }
  function paint(ctx, size, p, guides) {
    const originalPiece=p;
    if((p.artMode||'upload')==='upload')p={...p,labelTitle:'',labelArtist:'',songTitles:'',sideText:'',catalogText:'',creditsText:'',backgroundEnabled:false,ring:'none'};
    const font=p.textFont||'Arial';
    if(guides){p.hitRegions=[];originalPiece.hitRegions=p.hitRegions;}
    function textBlock(key,box,draw){const offset=p.textPositions?.[key]||{x:0,y:0};ctx.save();ctx.translate(offset.x*size,offset.y*size);draw();ctx.restore();if(guides&&p[key]?.trim())p.hitRegions.push({kind:'text',key,x:box[0]+offset.x,y:box[1]+offset.y,w:box[2],h:box[3]});}

    ctx.clearRect(0, 0, size, size);
    ctx.save();

    if (p.circle) {
      ctx.beginPath();
      ctx.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2);
      ctx.clip();
    }

    if(p.backgroundEnabled){
      ctx.fillStyle=p.backgroundColor||'#171717';ctx.fillRect(0,0,size,size);ctx.fillStyle=p.accentColor||'#b51f2e';
      switch(p.backgroundPattern){
        case 'halves':ctx.fillRect(0,size/2,size,size/2);break;
        case 'vertical':ctx.fillRect(size/2,0,size/2,size);break;
        case 'diagonal':ctx.beginPath();ctx.moveTo(0,size);ctx.lineTo(size,0);ctx.lineTo(size,size);ctx.closePath();ctx.fill();break;
        case 'semicircle':ctx.beginPath();ctx.arc(size/2,size/2,size*.42,0,Math.PI);ctx.closePath();ctx.fill();break;
        case 'band':ctx.fillRect(0,size*.35,size,size*.3);break;
        case 'circle':ctx.beginPath();ctx.arc(size/2,size/2,size*.29,0,Math.PI*2);ctx.fill();break;
      }
    }
    if(p.artMode==='design')(p.shapes||[]).forEach((shape,index)=>{
      ctx.save();ctx.translate(size*(.5+shape.x),size*(.5+shape.y));ctx.rotate(shape.angle*Math.PI/180);ctx.scale(shape.scale,shape.scale);ctx.globalAlpha=shape.opacity;ctx.fillStyle=shape.color;ctx.strokeStyle=shape.color;ctx.lineWidth=size*.012;
      ctx.beginPath();
      if(shape.type==='circle'||shape.type==='ring')ctx.arc(0,0,size/2,0,Math.PI*2);
      else if(shape.type==='semicircle'){ctx.arc(0,0,size/2,0,Math.PI);ctx.closePath();}
      else if(shape.type==='triangle'){ctx.moveTo(0,-size/2);ctx.lineTo(size/2,size/2);ctx.lineTo(-size/2,size/2);ctx.closePath();}
      else ctx.rect(-size/2,shape.type==='band'?-size*.12:-size/2,size,shape.type==='band'?size*.24:size);
      if(shape.type==='ring'||shape.type==='frame')ctx.stroke();else ctx.fill();ctx.restore();
      if(guides){const h=(shape.type==='band'?.24:1)*shape.scale,w=shape.scale,a=shape.angle*Math.PI/180,bw=Math.abs(w*Math.cos(a))+Math.abs(h*Math.sin(a)),bh=Math.abs(w*Math.sin(a))+Math.abs(h*Math.cos(a));p.hitRegions.push({kind:'shape',index,x:.5+shape.x-bw/2,y:.5+shape.y-bh/2,w:bw,h:bh});}
    });
    for(const layer of [p,...(p.artMode==='design'?p.layers||[]:[])]){
    if (layer.image) {
      ctx.save();
      ctx.translate(size * (.5 + layer.x), size * (.5 + layer.y));
      ctx.rotate(layer.angle * Math.PI / 180);

      const scale = imageScale({...p,...layer}) * size / (p.inch * DPI);

      ctx.scale(scale, scale);
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';

      ctx.drawImage(
        layer.image,
        -layer.image.naturalWidth / 2,
        -layer.image.naturalHeight / 2
      );
      ctx.restore();
      if(guides){const w=layer.image.naturalWidth*scale/size,h=layer.image.naturalHeight*scale/size,a=layer.angle*Math.PI/180;const bw=Math.abs(w*Math.cos(a))+Math.abs(h*Math.sin(a)),bh=Math.abs(w*Math.sin(a))+Math.abs(h*Math.cos(a));p.hitRegions.push({kind:'image',index:layer===p?-1:p.layers.indexOf(layer),x:.5+layer.x-bw/2,y:.5+layer.y-bh/2,w:bw,h:bh});}
    }

    }

    ctx.restore();
    ctx.save();
    if(p.circle){ctx.beginPath();ctx.arc(size/2,size/2,size/2,0,Math.PI*2);ctx.clip();}
    ctx.fillStyle=p.textColor||'#ffd54f';ctx.strokeStyle=ctx.fillStyle;ctx.lineWidth=size*.003;
    if(p.ring&&p.ring!=='none'){for(const radius of p.ring==='double'?[.45,.29]:[.45]){ctx.beginPath();ctx.arc(size/2,size/2,size*radius,0,Math.PI*2);ctx.stroke();}}
    const fontSize=size*(p.textSize||5)/100;
    const curved=p.circle&&(p.textLayout||'curve')==='curve';
    ctx.font='700 '+fontSize+'px '+font;ctx.textAlign='center';ctx.textBaseline='middle';
    textBlock('labelTitle',curved?[.1,.10,.8,.21]:[.1,.25-fontSize/size/2,.8,fontSize/size],()=>{if(curved)curvedText(ctx,p.labelTitle||'',size,size*.36,false,fontSize,font);else ctx.fillText(p.labelTitle||'',size/2,size*.25,size*.8);});
    textBlock('labelArtist',curved?[.1,.69,.8,.21]:[.1,.75-fontSize/size/2,.8,fontSize/size],()=>{if(curved)curvedText(ctx,p.labelArtist||'',size,size*.36,true,fontSize,font);else ctx.fillText(p.labelArtist||'',size/2,size*.75,size*.8);});
    // Keep detail text away from the center spindle hole and outer title arcs.
    ctx.textAlign='center';ctx.textBaseline='middle';ctx.font='500 '+(size*.023)+'px '+font;
    const songs=(p.songTitles||'').split(/\r?\n/).map(t=>t.trim()).filter(Boolean).slice(0,5);
    textBlock('songTitles',[.19,.306,.62,Math.max(.026,songs.length*.026)],()=>songs.forEach((line,i)=>ctx.fillText(line,size*.5,size*(.32+i*.026),size*.62)));
    ctx.font='700 '+(size*.021)+'px '+font;
    textBlock('sideText',[.13,.493,.30,.034],()=>ctx.fillText(p.sideText||'',size*.28,size*.51,size*.30));
    textBlock('catalogText',[.57,.493,.30,.034],()=>ctx.fillText(p.catalogText||'',size*.72,size*.51,size*.30));
    ctx.font='400 '+(size*.019)+'px '+font;
    const credits=(p.creditsText||'').split(/\r?\n/).filter(Boolean);
    const lines=[];for(const line of credits){let row='';for(const word of line.split(/\s+/)){const next=row?row+' '+word:word;if(row&&ctx.measureText(next).width>size*.62){lines.push(row);row=word;}else row=next;}if(row)lines.push(row);}
    textBlock('creditsText',[.19,.586,.62,Math.max(.025,Math.min(3,lines.length)*.025)],()=>lines.slice(0,3).forEach((line,i)=>ctx.fillText(line,size*.5,size*(.60+i*.025),size*.62)));
    ctx.restore();

    if (p.circle) {
      ctx.save();
      ctx.globalCompositeOperation = 'destination-out';
      ctx.beginPath();
      ctx.arc(
        size / 2,
        size / 2,
        HOLE / p.inch * size / 2,
        0,
        Math.PI * 2
      );
      ctx.fill();
      ctx.restore();
    }

    if (guides) {
      const selected=p.hitRegions?.find(h=>p.selectedShape>=0?h.kind==='shape'&&h.index===p.selectedShape:p.selectedText?h.kind==='text'&&h.key===p.selectedText:h.kind==='image'&&h.index===(p.selectedLayer??-1));
      if(selected){ctx.save();ctx.strokeStyle='#30e7bf';ctx.lineWidth=2;ctx.setLineDash([5,3]);ctx.strokeRect(selected.x*size,selected.y*size,selected.w*size,selected.h*size);ctx.restore();}
      ctx.save();
      ctx.strokeStyle = '#ffd54f';
      ctx.lineWidth = 1.5;
      ctx.setLineDash([5, 5]);
      ctx.beginPath();

      if (p.circle) {
        ctx.arc(size / 2, size / 2, size / 2 - 1, 0, Math.PI * 2);
      } else {
        ctx.rect(1, 1, size - 2, size - 2);
      }

      ctx.stroke();
      ctx.restore();
    }
  }

  const crcTable = Array.from({ length: 256 }, (_, n) => {
    for (let k = 0; k < 8; k++) {
      n = (n & 1) ? 0xedb88320 ^ (n >>> 1) : n >>> 1;
    }

    return n >>> 0;
  });

  function crc32(bytes) {
    let c = 0xffffffff;

    for (const n of bytes) {
      c = crcTable[(c ^ n) & 255] ^ (c >>> 8);
    }

    return (c ^ 0xffffffff) >>> 0;
  }

  function concatBytes(parts) {
    const n = parts.reduce((sum, part) => sum + part.length, 0);
    const out = new Uint8Array(n);
    let at = 0;

    for (const part of parts) {
      out.set(part, at);
      at += part.length;
    }

    return out;
  }

  function ascii(text) {
    return Uint8Array.from(text, c => c.charCodeAt(0));
  }

  function pngChunk(type, data) {
    const out = new Uint8Array(data.length + 12);
    const v = new DataView(out.buffer);

    v.setUint32(0, data.length);
    out.set(ascii(type), 4);
    out.set(data, 8);

    v.setUint32(
      out.length - 4,
      crc32(out.subarray(4, out.length - 4))
    );

    return out;
  }

  function png300(bytes) {
    const signature = [137, 80, 78, 71, 13, 10, 26, 10];

    if (
      bytes.length < 33 ||
      signature.some((n, i) => bytes[i] !== n)
    ) {
      throw Error('PNG export failed.');
    }

    const physical = new Uint8Array(9);
    const v = new DataView(physical.buffer);
    const ppm = Math.round(DPI / .0254);

    v.setUint32(0, ppm);
    v.setUint32(4, ppm);
    physical[8] = 1;

    const parts = [bytes.subarray(0, 8)];
    let at = 8;
    let inserted = false;
    let ended = false;

    while (at + 12 <= bytes.length) {
      const len = new DataView(
        bytes.buffer,
        bytes.byteOffset + at,
        4
      ).getUint32(0);

      if (at + 12 + len > bytes.length) {
        throw Error('Incomplete PNG export.');
      }

      const type = String.fromCharCode(
        ...bytes.subarray(at + 4, at + 8)
      );

      if (type !== 'pHYs') {
        parts.push(bytes.subarray(at, at + 12 + len));
      }

      if (type === 'IHDR') {
        parts.push(pngChunk('pHYs', physical));
        inserted = true;
      }

      at += 12 + len;

      if (type === 'IEND') {
        ended = true;
        break;
      }
    }

    if (!inserted || !ended) {
      throw Error('Incomplete PNG export.');
    }

    return concatBytes(parts);
  }

  function zipBytes(files) {
    const locals = [];
    const central = [];
    let offset = 0;

    for (const file of files) {
      const name = ascii(file.name);
      const bytes = file.bytes;
      const crc = crc32(bytes);

      const local = new Uint8Array(30 + name.length);
      const l = new DataView(local.buffer);

      l.setUint32(0, 0x04034b50, true);
      l.setUint16(4, 20, true);
      l.setUint16(12, 33, true);
      l.setUint32(14, crc, true);
      l.setUint32(18, bytes.length, true);
      l.setUint32(22, bytes.length, true);
      l.setUint16(26, name.length, true);

      local.set(name, 30);
      locals.push(local, bytes);

      const dir = new Uint8Array(46 + name.length);
      const d = new DataView(dir.buffer);

      d.setUint32(0, 0x02014b50, true);
      d.setUint16(4, 20, true);
      d.setUint16(6, 20, true);
      d.setUint16(14, 33, true);
      d.setUint32(16, crc, true);
      d.setUint32(20, bytes.length, true);
      d.setUint32(24, bytes.length, true);
      d.setUint16(28, name.length, true);
      d.setUint32(42, offset, true);

      dir.set(name, 46);
      central.push(dir);
      offset += local.length + bytes.length;
    }

    const directory = concatBytes(central);
    const end = new Uint8Array(22);
    const e = new DataView(end.buffer);

    e.setUint32(0, 0x06054b50, true);
    e.setUint16(8, files.length, true);
    e.setUint16(10, files.length, true);
    e.setUint32(12, directory.length, true);
    e.setUint32(16, offset, true);

    return concatBytes([...locals, directory, end]);
  }

  window.__lcvrArtworkTools={async releaseZip(file,extras){
    const files=[];
    if(file){const bytes=new Uint8Array(await file.arrayBuffer()),d=new DataView(bytes.buffer);let pos=0;
      while(pos+30<=bytes.length&&d.getUint32(pos,true)===0x04034b50){const flags=d.getUint16(pos+6,true),method=d.getUint16(pos+8,true),n=d.getUint32(pos+18,true),nl=d.getUint16(pos+26,true),xl=d.getUint16(pos+28,true),start=pos+30+nl+xl;if(flags&9||method!==0||start+n>bytes.length)throw Error('Re-save your artwork in the designer before checkout.');files.push({name:new TextDecoder().decode(bytes.slice(pos+30,pos+30+nl)),bytes:bytes.slice(start,start+n)});pos=start+n;}
      if(!files.length)throw Error('Artwork archive could not be read. Re-save the artwork.');
    }
    for(const item of extras){if(files.some(f=>f.name===item.name))throw Error('Duplicate release document name.');files.push(item);}
    return zipBytes(files);
  }};

  document.querySelectorAll('[data-lcvr-lab]').forEach(root => {
    if (root.dataset.labReady) return;
    root.dataset.labReady = '1';

    const q = selector => root.querySelector(selector);
    const out = name => q('[data-output="' + name + '"]');
    const ctl = name => q('[data-control="' + name + '"]');

    const dialog = q('dialog');
    const canvas = ctl('canvas');
    const ctx = canvas.getContext('2d');
    const sessions = {};

    let size = 7;
    let project = null;
    let index = 0;
    let view = 'choose';
    let busy = false;
    let drag = null;

    root.__lcvrArtworkDesigner={get busy(){return busy;},reset(){if(busy)throw Error('Wait for artwork processing to finish.');for(const key of Object.keys(sessions))delete sessions[key];project=null;index=0;size=7;drag=null;root.querySelectorAll('input[type=file]').forEach(el=>el.value='');delete root.dataset.checkoutArtMode;ctx.clearRect(0,0,canvas.width,canvas.height);packageOptions();show('choose');}};
    const current = () => project && project.pieces[index];

    const say = text => {
      out('message').textContent = text;
    };

    function show(name) {
      view = name;
      say('');

      root.querySelectorAll('[data-view]').forEach(el => {
        el.hidden = el.dataset.view !== name;
      });

      root.querySelectorAll('[data-stage]').forEach(el => {
        if (el.dataset.stage === name) {
          el.setAttribute('aria-current', 'step');
        } else {
          el.removeAttribute('aria-current');
        }
      });

      if (name === 'edit') render();
      if (name === 'review') review();

      dialog.scrollTop = 0;
    }

    function packageOptions() {
      ctl('package').replaceChildren();

      const options = size === 10
        ? [['cnc', 'CNC engraving artwork']]
        : [
          ['all', 'Labels + jacket front and back'],
          ['labels', 'Label A + Label B only'],
          ['jacket', 'Jacket front + back only']
        ];

      for (const [value, text] of options) {
        const option = document.createElement('option');
        option.value = value;
        option.textContent = text;
        ctl('package').append(option);
      }
    }

    function render() {
      if (!project) return;

      const p = current();
      const n = Math.round(p.inch * DPI);

      out('pieces').replaceChildren();

      project.pieces.forEach((piece, i) => {
        const button = document.createElement('button');

        button.type = 'button';
        button.dataset.piece = String(i);
        button.textContent = (piece.ready ? '✓ ' : '') + piece.title;
        button.setAttribute('aria-current', String(i === index));

        out('pieces').append(button);
      });

      out('completion').textContent =
        project.pieces.filter(piece => piece.ready).length +
        ' / ' + project.pieces.length + ' pieces saved';

      const artProgress=root.querySelector('[data-art-progress]');artProgress.max=project.pieces.length;artProgress.value=project.pieces.filter(piece=>piece.ready).length;
      out('piece-count').textContent =
        'ARTWORK ' + (index + 1) + ' OF ' + project.pieces.length;

      out('piece-title').textContent = p.title.toUpperCase();
      const nextPiece=project.pieces.find((piece,i)=>i>index&&!piece.ready)||project.pieces.find((piece,i)=>i!==index&&!piece.ready);
      const nextButton=root.querySelector('[data-action="next"]');
      if(nextButton)nextButton.textContent=nextPiece?'SAVE '+p.title.toUpperCase()+' & NEXT: '+nextPiece.title.toUpperCase()+' →':'SAVE '+p.title.toUpperCase()+' & REVIEW ARTWORK →';

      out('dimensions').textContent =
        p.inch + '″ ' +
        (p.circle ? 'circle · .313″ center hole' : '× ' + p.inch + '″ square') +
        ' · ' + n + ' × ' + n + ' px · 300 DPI PNG';

      out('filename').textContent =
        p.filename || 'No image selected';

      const selected=activeImage(p);
      ctl('zoom').value = selected.zoom;
      ctl('angle').value = selected.angle;

      out('zoom').textContent = Math.round(selected.zoom * 100) + '%';
      out('angle').textContent = selected.angle + '°';
      out('empty').hidden = hasDesign(p);
      for(const key of ['labelTitle','labelArtist','songTitles','sideText','catalogText','creditsText','textLayout','textSize','textColor','backgroundColor','backgroundPattern','accentColor','textFont','ring'])ctl(key).value=p[key]??({textLayout:'curve',textSize:5,textColor:'#ffd54f',backgroundColor:'#171717',backgroundPattern:'solid',accentColor:'#b51f2e',textFont:'Arial',ring:'none'}[key]||'');
      ctl('backgroundEnabled').checked=!!p.backgroundEnabled;
      const mode=p.artMode||'upload';
      root.querySelector('[data-vintage-tools]').hidden=mode!=='design';
      const shapeSelect=root.querySelector('[data-shape-select]');shapeSelect.replaceChildren();
      const blank=document.createElement('option');blank.value='-1';blank.textContent='Select a shape';shapeSelect.append(blank);
      (p.shapes||[]).forEach((shape,i)=>{const option=document.createElement('option');option.value=String(i);option.textContent=(i+1)+'. '+shape.type;shapeSelect.append(option);});shapeSelect.value=String(p.selectedShape??-1);
      const shape=p.shapes?.[p.selectedShape];for(const key of ['color','opacity','scale','angle']){const input=root.querySelector('[data-shape-'+key+']');input.disabled=busy||!shape;if(shape)input.value=shape[key];}
      root.querySelectorAll('[data-shape-action]').forEach(b=>b.disabled=busy||(b.dataset.shapeAction!=='add'&&!shape));

      const layerTools=root.querySelector('[data-layer-tools]');layerTools.hidden=mode!=='design';
      const layerSelect=root.querySelector('[data-layer-select]');layerSelect.replaceChildren();
      const base=document.createElement('option');base.value='-1';base.textContent=p.filename||'Base image (none)';layerSelect.append(base);
      (p.layers||[]).forEach((layer,i)=>{const option=document.createElement('option');option.value=String(i);option.textContent=(i+1)+'. '+layer.filename;layerSelect.append(option);});
      layerSelect.value=String(p.selectedLayer??-1);
      root.querySelectorAll('[data-layer-action]').forEach(b=>b.disabled=busy||!(p.selectedLayer>=0));
root.querySelector('.lal-text-tools').hidden=mode!=='design';
      root.querySelectorAll('[data-art-mode]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.artMode===mode)));
      root.querySelector('[data-design-mode-note]').textContent=mode==='upload'?'Upload your finished artwork. The record and template size are already selected. Check the dimensions and print resolution below; no design work is required.':'Build with text, two-tone colors and shapes. You can also upload a logo or background image.';

      out('tip').textContent = p.key === 'CNC-Artwork'
        ? 'Bold, high-contrast artwork works best for CNC engraving.'
        : p.circle
          ? 'Circle edges and the permanent 0.313″ center hole export transparent.'
          : 'Your image is fitted to this jacket face. Transparent areas stay transparent.';

      const ppi = selected.image ? Math.round(DPI / imageScale({...p,...selected})) : 0;

      const quality=out('quality');
      quality.setAttribute('role','status');
      quality.style.whiteSpace='pre-line';
      const targetPixels=Math.round(p.inch*DPI);
      const requirement='Required for your '+size+'-inch record: '+p.title+' · '+p.inch+'″ '+(p.circle?'circle':'square')+' · '+targetPixels+' × '+targetPixels+' px recommended at 300 DPI.';
      if(selected.image){
        const w=selected.image.naturalWidth,h=selected.image.naturalHeight;
        const square=w===h;
        quality.textContent=requirement+'\nUploaded: '+w+' × '+h+' px · about '+ppi+' DPI at the current size.\n'+
          (square?'Shape matches the square artwork canvas.':'Check shape: this image is not square. Fill crops its edges; Fit keeps the whole image. Review the preview before saving.')+'\n'+
          (ppi>=300?'Resolution meets the 300 DPI recommendation.':'Low-resolution warning: use a larger original image for sharper printing. Exporting at 300 DPI cannot restore missing detail.');
        quality.dataset.check=ppi>=300&&square?'ready':'warning';
      }else{quality.textContent=requirement+'\nUpload the finished image for this piece to check its size and resolution.';quality.dataset.check='waiting';}

      for (const action of ['png', 'print', 'next', 'fill', 'fit', 'reset']) {
        q('[data-action="' + action + '"]').disabled =
          busy || (['png','print','next'].includes(action)?!hasDesign(p):!selected.image);
      }

      paint(ctx, 600, p, true);
      let mock=root.querySelector('[data-product-mock]');
      if(!mock){const figure=document.createElement('figure');figure.className='lal-product-mock';figure.innerHTML='<canvas width="600" height="600" data-product-mock aria-label="Artwork placement on your record"></canvas><figcaption></figcaption>';canvas.closest('.lal-canvas-wrap').parentElement.append(figure);mock=figure.querySelector('canvas');}
      const preview=mock.getContext('2d'), artwork=document.createElement('canvas');artwork.width=600;artwork.height=600;paint(artwork.getContext('2d'),600,p,false);
      preview.clearRect(0,0,600,600);preview.fillStyle='#161616';preview.fillRect(0,0,600,600);
      if(p.circle){preview.fillStyle='#080808';preview.beginPath();preview.arc(300,300,280,0,Math.PI*2);preview.fill();for(let radius=125;radius<277;radius+=5){preview.strokeStyle='rgba(255,255,255,.09)';preview.lineWidth=1;preview.beginPath();preview.arc(300,300,radius,0,Math.PI*2);preview.stroke();}const label=560*p.inch/project.size;preview.drawImage(artwork,300-label/2,300-label/2,label,label);preview.fillStyle='#161616';preview.beginPath();preview.arc(300,300,Math.max(3,560*.313/project.size/2),0,Math.PI*2);preview.fill();}
      else{preview.fillStyle='#eee';preview.fillRect(30,30,540,540);preview.drawImage(artwork,30,30,540,540);preview.strokeStyle='#555';preview.strokeRect(30,30,540,540);}
      mock.parentElement.querySelector('figcaption').textContent=project.size+'″ '+(p.circle?'record · ':'jacket · ')+p.title+' · placement preview';

    }

    function changed() {
      window.dispatchEvent(new CustomEvent('lcvr:artwork-changed'));
      current().ready = false;
      render();
      say('');
    }

    function setBusy(flag) {
      busy = flag;

      root.querySelectorAll('button,input,select,textarea').forEach(el => {
        el.disabled = flag;
      });

      if (!flag && view === 'edit') render();
    }

    function fileName(p) {
      return 'LCVR-' + project.size + 'in-' + p.key + '.png';
    }

    function download(bytes, name, type) {
      const url = URL.createObjectURL(new Blob([bytes], { type }));
      const link = document.createElement('a');

      link.href = url;
      link.download = name;
      link.hidden = true;

      root.append(link);
      link.click();
      link.remove();

      setTimeout(() => URL.revokeObjectURL(url), 30000);
    }

    async function png(p) {
      const c = document.createElement('canvas');
      c.width = c.height = Math.round(p.inch * DPI);

      try {
        paint(c.getContext('2d'), c.width, p, false);

        const blob = await new Promise((resolve, reject) => {
          c.toBlob(
            result => result
              ? resolve(result)
              : reject(Error('Image export failed.')),
            'image/png'
          );
        });

        return png300(new Uint8Array(await blob.arrayBuffer()));
      } finally {
        c.width = c.height = 0;
      }
    }

    async function exportOne(p) {
      setBusy(true);
      say('Preparing your PNG…');

      try {
        download(await png(p), fileName(p), 'image/png');
        say('PNG prepared. Check your browser downloads.');
      } finally {
        setBusy(false);
      }
    }

    async function exportZip(attach=false) {
      if (project.pieces.some(p => !p.ready)) {
        say('Save each artwork piece before downloading the complete ZIP.');
        return;
      }

      setBusy(true);

      try {
        const files = [];

        for (let i = 0; i < project.pieces.length; i++) {
          const p = project.pieces[i];

          say(
            'Preparing artwork ' + (i + 1) +
            ' of ' + project.pieces.length + '…'
          );

          await new Promise(resolve => setTimeout(resolve, 0));

          files.push({
            name: fileName(p),
            bytes: await png(p)
          });
        }

        const archive=zipBytes(files),name='LCVR-'+project.size+'in-Artwork.zip';
        if(attach){window.dispatchEvent(new CustomEvent('lcvr:artwork',{detail:{file:new File([archive],name,{type:'application/zip'}),size:project.size,pieces:project.pieces.map(p=>p.key)}}));}
        else download(archive,name,'application/zip');

        say(
          attach ? 'Artwork saved to this release. Review your record below.' : 'ZIP downloaded. You can also use Save artwork to this release to attach it automatically.'
        );
      } finally {
        setBusy(false);
      }
    }

    function review() {
      out('review').replaceChildren();

      project.pieces.forEach((p, i) => {
        const card = document.createElement('article');
        const thumb = document.createElement('canvas');

        thumb.width = thumb.height = 300;
        thumb.setAttribute('aria-label', p.title + ' preview');

        paint(thumb.getContext('2d'), 300, p, false);

        const title = document.createElement('h4');
        title.textContent = p.title;

        const edit = document.createElement('button');
        edit.type = 'button';
        edit.dataset.piece = String(i);
        edit.textContent = 'EDIT';

        const save = document.createElement('button');
        save.type = 'button';
        save.dataset.png = String(i);
        save.textContent = 'PNG ↓';

        card.append(thumb, title, edit, save);
        out('review').append(card);
      });
    }

    const attachButton = root.querySelector('[data-action="attach-order"]');
    if(attachButton) attachButton.addEventListener('click', async event => {
      event.preventDefault();event.stopPropagation();
      if(busy)return;
      try { await exportZip(true); } catch(error) { say(error.message || 'Artwork could not be prepared.'); }
    });
    root.addEventListener('click', async event => {
      const button = event.target.closest('button');

      if (!button || !root.contains(button) || busy) return;

      try {
        if (button.dataset.size) {
          size = Number(button.dataset.size);

          root.querySelectorAll('[data-size]').forEach(b => {
            b.setAttribute(
              'aria-pressed',
              String(Number(b.dataset.size) === size)
            );
          });

          packageOptions();
          return;
        }

        if (button.dataset.piece !== undefined) {
          index = Number(button.dataset.piece);
          show('edit');
          return;
        }

        if (button.dataset.png !== undefined) {
          await exportOne(
            project.pieces[Number(button.dataset.png)]
          );
          return;
        }

        const action = button.dataset.action;
        const p = current();

        if (action === 'open') {
          dialog.showModal();
          show(view);
        } else if (action === 'close') {
          dialog.close();
        } else if (action === 'choose') {
          show('choose');
        } else if (action === 'start') {
          const pack = ctl('package').value;
          const key = size + ':' + pack;

          if (!sessions[key]) {
            sessions[key] = {
              size,
              pieces: piecesFor(size, pack).map(piece => ({
                ...piece,
                image: null,
                filename: '',
                x: 0,
                y: 0,
                angle: 0,
                zoom: 1,
                mode: 'fill',
                ready: false
              }))
            };
          }

          project = sessions[key];
          if(root.dataset.checkoutArtMode)for(const piece of project.pieces)piece.artMode=root.dataset.checkoutArtMode;
          index = 0;
          show('edit');
        } else if (action === 'edit') {
          show('edit');
        } else if (action === 'fill' || action === 'fit') {
          const target=activeImage(p);
          target.mode = action;
          target.zoom = 1;
          target.x = target.y = 0;
          changed();
        } else if (action === 'reset') {
          const target=activeImage(p);target.x = target.y = target.angle = 0;
          target.zoom = 1;
          target.mode = 'fill';
          changed();
        } else if (action === 'print' && hasDesign(p)) {
          const preview=document.createElement('dialog');preview.style.cssText='width:min(900px,94vw);max-height:92vh;background:#fff;color:#111;padding:20px;border:1px solid #444;border-radius:12px';
          const close=document.createElement('button');close.textContent='Close print preview';close.type='button';close.onclick=()=>{preview.close();preview.remove();};
          const frame=document.createElement('iframe');frame.title='Artwork print sheet';frame.style.cssText='display:block;width:100%;height:70vh;border:0;margin-top:12px';
          preview.append(close,frame);document.body.append(preview);preview.showModal();
          const sheet=frame.contentWindow;
          const c=document.createElement('canvas');c.width=c.height=Math.round(p.inch*300);paint(c.getContext('2d'),c.width,p,false);
          sheet.document.title='LCVR artwork — '+p.title;
          const style=sheet.document.createElement('style');style.textContent='body{margin:20px;font:16px Arial;background:white;color:black}img{display:block;width:'+p.inch+'in;height:'+p.inch+'in;max-width:none}button{padding:12px 20px;margin:12px 0}@media print{@page{margin:0}body{margin:0}header{display:none}}';sheet.document.head.append(style);
          const header=sheet.document.createElement('header'),info=sheet.document.createElement('p'),button=sheet.document.createElement('button');
          info.textContent=p.title+' · '+p.inch+' inch'+(p.circle?' · .313″ center hole':'')+'. Print at 100% / Actual size. Choose paper large enough for the artwork; turn off Fit to page.';
          button.textContent='Print artwork';button.onclick=()=>sheet.print();header.append(info,button);sheet.document.body.append(header);
          const image=sheet.document.createElement('img');image.alt=p.title;image.src=c.toDataURL('image/png');sheet.document.body.append(image);
        } else if (action === 'png' && hasDesign(p)) {
          await exportOne(p);
        } else if (action === 'next' && hasDesign(p)) {
          p.ready = true;

          let next = project.pieces.findIndex(
            (piece, i) => i > index && !piece.ready
          );

          if (next < 0) {
            next = project.pieces.findIndex(piece => !piece.ready);
          }

          if (next < 0) {
            show('review');
          } else {
            index = next;
            show('edit');
          }
        } else if (action === 'attach-order') {
          await exportZip(true);
        } else if (action === 'zip') {
          await exportZip();
        }
      } catch (error) {
        say(error.message || 'Something went wrong. Please try again.');
      }
    });

    ctl('file').addEventListener('change', async event => {
      const file = event.target.files[0];

      if (!file || busy || !current()) return;

      if (!/\.(png|jpe?g|webp)$/i.test(file.name)) {
        say('Choose a PNG, JPG or WebP image.');
        event.target.value = '';
        return;
      }

      const p = current();
      const url = URL.createObjectURL(file);

      setBusy(true);
      say('Opening your image…');

      try {
        const image = await new Promise((resolve, reject) => {
          const img = new Image();

          img.onload = () => resolve(img);

          img.onerror = () => reject(
            Error('This image could not be opened. Try a PNG or JPG.')
          );

          img.src = url;
        });

        p.image = image;
        p.filename = file.name;
        p.x = p.y = p.angle = 0;
        p.zoom = 1;
        p.mode = 'fill';
        p.ready = false;
        window.dispatchEvent(new CustomEvent('lcvr:artwork-changed'));
        say('');
      } catch (error) {
        say(error.message);
      } finally {
        URL.revokeObjectURL(url);
        event.target.value = '';
        setBusy(false);
      }
    });

    root.querySelector('[data-shape-select]').addEventListener('change',event=>{if(busy||!current())return;current().selectedShape=Number(event.target.value);current().selectedText=null;render();});
    root.querySelectorAll('[data-shape-action]').forEach(button=>button.addEventListener('click',()=>{
      if(busy||!current())return;const p=current(),action=button.dataset.shapeAction,i=p.selectedShape;p.shapes??=[];
      if(action==='add'){p.shapes.push({type:root.querySelector('[data-shape-type]').value,x:0,y:0,scale:.6,angle:0,opacity:.4,color:p.accentColor||'#c64036'});p.selectedShape=p.shapes.length-1;p.selectedText=null;}
      else if(p.shapes[i]){if(action==='remove'){p.shapes.splice(i,1);p.selectedShape=-1;}else{const j=action==='front'?Math.min(i+1,p.shapes.length-1):Math.max(0,i-1);[p.shapes[i],p.shapes[j]]=[p.shapes[j],p.shapes[i]];p.selectedShape=j;}}changed();
    }));
    for(const key of ['color','opacity','scale','angle'])root.querySelector('[data-shape-'+key+']').addEventListener('input',event=>{if(busy||!current())return;const shape=current().shapes?.[current().selectedShape];if(!shape)return;shape[key]=key==='color'?event.target.value:Number(event.target.value);changed();});
    root.querySelector('[data-layer-select]').addEventListener('change',event=>{if(busy||!current())return;current().selectedShape=-1;current().selectedText=null;current().selectedLayer=Number(event.target.value);render();});
    root.querySelectorAll('[data-layer-action]').forEach(button=>button.addEventListener('click',()=>{
      if(busy||!current())return;const p=current(),i=p.selectedLayer;if(!(i>=0)||!p.layers?.[i])return;
      if(button.dataset.layerAction==='remove'){p.layers.splice(i,1);p.selectedLayer=p.layers.length-1;}
      else{const next=button.dataset.layerAction==='front'?Math.min(i+1,p.layers.length-1):Math.max(0,i-1);[p.layers[i],p.layers[next]]=[p.layers[next],p.layers[i]];p.selectedLayer=next;}changed();
    }));
    root.querySelector('[data-layer-upload]').addEventListener('change',async event=>{
      if(busy||!current())return;const p=current(),files=Array.from(event.target.files||[]);if(!files.length)return;setBusy(true);
      try{for(let i=0;i<files.length;i++){
        const file=files[i];if(!/\.(png|jpe?g|webp)$/i.test(file.name))throw Error('Choose PNG, JPG or WebP images.');
        say('Opening image '+(i+1)+' of '+files.length+'…');const url=URL.createObjectURL(file);
        try{const image=await new Promise((resolve,reject)=>{const img=new Image();img.onload=()=>resolve(img);img.onerror=()=>reject(Error('Could not open '+file.name));img.src=url;});
          (p.layers??=[]).push({image,filename:file.name,x:0,y:0,angle:0,zoom:.5,mode:'fit'});p.selectedLayer=p.layers.length-1;p.selectedText=null;p.selectedShape=-1;
        }finally{URL.revokeObjectURL(url);}
      }changed();}catch(error){say(error.message);p.ready=false;window.dispatchEvent(new CustomEvent('lcvr:artwork-changed'));}finally{event.target.value='';setBusy(false);}
    });
    const printButton=document.createElement('button');
    printButton.type='button';printButton.dataset.action='print';printButton.textContent='PRINT THIS ARTWORK';
    root.querySelector('[data-action="png"]').after(printButton);
    const clearText=document.createElement('button');
    clearText.type='button';clearText.textContent='CLEAR ALL LABEL TEXT';clearText.dataset.clearLabelText='';
    root.querySelector('.lal-text-tools summary').after(clearText);
    clearText.addEventListener('click',()=>{
      if(busy||!current())return;
      const p=current();
      for(const key of ['labelTitle','labelArtist','songTitles','sideText','catalogText','creditsText'])p[key]='';
      p.selectedText=null;p.textPositions={};changed();say('Text cleared for this artwork piece. Your images are unchanged.');
    });
    root.querySelectorAll('[data-art-mode]').forEach(button=>button.addEventListener('click',()=>{
      if(busy||!current())return;const p=current();p.artMode=button.dataset.artMode;root.dataset.checkoutArtMode=p.artMode;
      if(p.artMode==='design'){p.backgroundEnabled=true;root.querySelector('.lal-text-tools').open=true;}changed();
    }));
    for(const name of ['labelTitle','labelArtist','songTitles','sideText','catalogText','creditsText','textLayout','textSize','textColor','backgroundColor','backgroundEnabled','backgroundPattern','accentColor','textFont','ring']){
      ctl(name).addEventListener('input',()=>{if(busy||!current())return;if(name==='songTitles'&&ctl(name).value.split(/\r?\n/).length>5){ctl(name).value=ctl(name).value.split(/\r?\n/).slice(0,5).join('\n');}current()[name]=name==='backgroundEnabled'?ctl(name).checked:name==='textSize'?Number(ctl(name).value):ctl(name).value;changed();});
    }
    for (const name of ['zoom', 'angle']) {
      ctl(name).addEventListener('input', () => {
        if (busy || !current()) return;

        activeImage(current())[name] = Number(ctl(name).value);

        changed();
      });
    }

    canvas.addEventListener('pointerdown', event => {
      if(busy||!current())return;const p=current(),rect=canvas.getBoundingClientRect(),x=(event.clientX-rect.left)/rect.width,y=(event.clientY-rect.top)/rect.height;
      const hit=[...(p.hitRegions||[])].reverse().find(h=>x>=h.x&&x<=h.x+h.w&&y>=h.y&&y<=h.y+h.h);
      if(!hit)return;
      p.selectedShape=hit.kind==='shape'?hit.index:-1;p.selectedText=hit.kind==='text'?hit.key:null;if(hit.kind==='image')p.selectedLayer=hit.index;
      event.preventDefault();render();
      canvas.setPointerCapture(event.pointerId);
      canvas.focus();

      drag = {
        id: event.pointerId,
        x: event.clientX,
        y: event.clientY
      };
    });

    canvas.addEventListener('pointermove', event => {
      if (!drag || drag.id !== event.pointerId || busy) return;

      const rect = canvas.getBoundingClientRect();
      const p = movingItem(current());

      p.x += (event.clientX - drag.x) / rect.width;
      p.y += (event.clientY - drag.y) / rect.height;

      drag.x = event.clientX;
      drag.y = event.clientY;

      changed();
    });

    const endDrag = () => { drag = null; };

    canvas.addEventListener('pointerup', endDrag);
    canvas.addEventListener('pointercancel', endDrag);

    canvas.addEventListener('keydown', event => {
      const directions = {
        ArrowLeft: [-1, 0],
        ArrowRight: [1, 0],
        ArrowUp: [0, -1],
        ArrowDown: [0, 1]
      };

      if (!directions[event.key] || (!current()||(!(current().selectedShape>=0)&&!current().selectedText&&!activeImage(current()).image)) || busy) return;

      event.preventDefault();

      const direction = directions[event.key];
      const step = event.shiftKey ? .05 : .01;

      movingItem(current()).x += direction[0] * step;
      movingItem(current()).y += direction[1] * step;

      changed();
    });

    dialog.addEventListener('cancel', event => {
      if (busy) event.preventDefault();
    });

    show('choose');
  });
})();

